export const state = {
    stock_rows: [],
    stock_loading: false,

    sales_summary: null,
    sales_top: null,
    sales_loading: false,
};

export const getters = {};

function blobDownload(response, fallbackName) {
    const disposition = response.headers && response.headers["content-disposition"];
    let filename = fallbackName;
    if (disposition) {
        const match = /filename="?([^"]+)"?/i.exec(disposition);
        if (match) filename = match[1];
    }
    const blob = new Blob([response.data], {
        type: response.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

export const actions = {
    getStockList({ commit }, params = {}) {
        commit("setStockLoading", true);
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/reports/stock", { params })
                .then((response) => {
                    commit("setStockRows", response.data);
                    commit("setStockLoading", false);
                    resolve(response.data);
                })
                .catch((error) => {
                    commit("setStockLoading", false);
                    reject(error);
                });
        });
    },
    // eslint-disable-next-line
    exportStockXlsx({}, params = {}) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/reports/stock/export", { params, responseType: "blob" })
                .then((response) => {
                    blobDownload(response, "stock-take.xlsx");
                    resolve();
                })
                .catch((error) => reject(error));
        });
    },
    // eslint-disable-next-line
    submitStockTake({}, payload) {
        return new Promise((resolve, reject) => {
            window.axios
                .post("api/reports/stock/reconcile", payload)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    },
    getSalesSummary({ commit }, params = {}) {
        commit("setSalesLoading", true);
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/reports/sales/summary", { params })
                .then((response) => {
                    commit("setSalesSummary", response.data);
                    commit("setSalesLoading", false);
                    resolve(response.data);
                })
                .catch((error) => {
                    commit("setSalesLoading", false);
                    reject(error);
                });
        });
    },
    getSalesTopProducts({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/reports/sales/top-products", { params })
                .then((response) => {
                    commit("setSalesTop", response.data);
                    resolve(response.data);
                })
                .catch((error) => reject(error));
        });
    },
    // eslint-disable-next-line
    exportSalesXlsx({}, params = {}) {
        return new Promise((resolve, reject) => {
            window.axios
                .get("api/reports/sales/export", { params, responseType: "blob" })
                .then((response) => {
                    blobDownload(response, "sales-report.xlsx");
                    resolve();
                })
                .catch((error) => reject(error));
        });
    },
};

export const mutations = {
    setStockRows(state, payload) {
        state.stock_rows = payload;
    },
    setStockLoading(state, payload) {
        state.stock_loading = payload;
    },
    setSalesSummary(state, payload) {
        state.sales_summary = payload;
    },
    setSalesTop(state, payload) {
        state.sales_top = payload;
    },
    setSalesLoading(state, payload) {
        state.sales_loading = payload;
    },
};
